import placeholder from '@/packages/components/base/swiper/src/assets/img/placeholder.png'
import { SWIPER_EVENTS, SWIPER_DATA_SOURCE } from '@/packages/components/hook/useSwiper'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-swiper', // 组件名
  type: 'component-base', // 组件类型
  label: '轮播', // 组件label
  icon: 'icon-xy-svga', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 400 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  /** 滑动方向: 'horizontal' | 'vertical' */
  direction: { type: String, default: 'horizontal' },
  /** 是否开启从右到左模式（适配阿拉伯语等 RTL 布局） */
  rtl: { type: String, default: 'ltr' },
  /** 当前激活的幻灯片索引 */
  activeIndex: { type: Number, default: 0 },
  /** 默认显示的幻灯片索引 */
  initialSlide: { type: Number, default: 0 },
  /** 是否开启循环轮播 */
  loop: { type: Boolean, default: false },
  /** 触摸灵敏度，值越大越灵敏 */
  touchRatio: { type: Number, default: 1.2 },
  /** 切换效果：'slide'(滑动) | 'fade'(淡入淡出) | 'cube'(3D立方体) | 'coverflow'(3D覆盖流) */
  effect: { type: String, default: 'slide' },
  /** 3D覆盖流效果-深度 */
  coverflowDepth: { type: Number, default: 50 },
  /** 3D覆盖流效果-修饰强度 */
  coverflowModifier: { type: Number, default: 1 },
  /** 3D覆盖流效果-旋转角度 */
  coverflowRotate: { type: Number, default: -35 },
  /** 3D覆盖流效果-缩放比例 */
  coverflowScale: { type: Number, default: 0.85 },
  /** 3D覆盖流效果-是否显示阴影 */
  coverflowShadow: { type: Boolean, default: true },
  /** 3D覆盖流效果-拉伸程度 */
  coverflowStretch: { type: Number, default: 0 },
  /** 同时显示的幻灯片数量 */
  slidesPerView: { type: Number, default: 1 },
  /** 幻灯片是否居中显示 */
  centeredSlides: { type: Boolean, default: true },
  /** 幻灯片之间的间距(px) */
  spaceBetween: { type: Number, default: 0 },
  /** 是否自动播放 */
  autoplay: { type: Boolean, default: false },
  /** 自动播放时间间隔，单位毫秒 */
  delay: { type: Number, default: 3000 },
  /** 最后一张停止自动播放 */
  stopOnLastSlide: { type: Boolean, default: false },
  /** 是否显示分页器 */
  showPagination: { type: Boolean, default: true },
  /** 分页器类型：'bullets'(圆点) | 'fraction'(分数) | 'progressbar'(进度条) */
  paginationType: { type: String, default: 'bullets' },
  /** 分页器位置 */
  paginationPosition: { type: String, default: 'bottom' },
  /** 分页器大小 */
  paginationBulletSize: { type: Number, default: 12 },
  /** 分页器激活状态的颜色 */
  paginationColor: { type: String, default: '#007aff' },
  /** 分页器未激活状态的颜色 */
  paginationInactiveColor: { type: String, default: '#000' },
  /** 分页器未激活状态的透明度 */
  paginationInactiveOpacity: { type: Number, default: 0.2 },
  /** 是否显示上一页/下一页导航按钮 */
  showNavigation: { type: Boolean, default: false },
  /** 是否启用鼠标滚轮控制 */
  mousewheel: { type: Boolean, default: true },
  /** 是否启用无障碍功能 */
  a11y: { type: Boolean, default: true },
  items: {
    type: Array, default: [
      {
        coverType: 1,
        cover: placeholder,
        fit: 'none'
      },
      {
        coverType: 1,
        cover: placeholder,
        fit: 'none'
      }
    ]
  }
}

/**
 * 组件开放方法事件
 */
export const events = SWIPER_EVENTS

/**
 * 组件开放数据源
 */
export const dataSource = SWIPER_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-input-number',
    label: '当前索引',
    propKey: 'activeIndex',
    min: 0,
    step: 1,
    labelWidth: '120px',
    isLanguage: true // 是否可多语言配置
  },
  {
    type: 'xy-form-input-number',
    label: '默认索引',
    propKey: 'initialSlide',
    min: 0,
    step: 1,
    labelWidth: '120px',
    isLanguage: true,
    isActivityData: true // 是否为动态数据
  },
  {
    type: 'xy-form-select',
    label: '滑动方向',
    propKey: 'direction',
    options: [
      { label: '水平', value: 'horizontal' },
      { label: '垂直', value: 'vertical' }
    ],
    labelWidth: '120px',
    isLanguage: true // 是否可多语言配置
  },
  {
    type: 'xy-form-select',
    label: '排版方向',
    propKey: 'rtl',
    options: [
      { label: '从左到右', value: 'ltr' },
      { label: '从右到左', value: 'rtl' }
    ],
    labelWidth: '120px',
    isLanguage: true // 是否可多语言配置
  },
  {
    type: 'xy-form-switch',
    label: '循环播放',
    propKey: 'loop',
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number',
    label: '触摸灵敏度',
    propKey: 'touchRatio',
    min: 1,
    max: 2,
    step: 0.1,
    precision: 1,
    labelWidth: '120px'
  },
  {
    type: 'xy-form-select',
    label: '切换效果',
    propKey: 'effect',
    options: [
      { label: '滑动', value: 'slide' },
      { label: '淡入淡出', value: 'fade' },
      { label: '3D覆盖流', value: 'coverflow' }
    ],
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number',
    label: '3D覆盖流效果深度',
    propKey: 'coverflowDepth',
    min: 0,
    max: 200,
    step: 10,
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number',
    label: '3D覆盖流效果强度',
    propKey: 'coverflowModifier',
    min: 0,
    max: 3,
    step: 0.1,
    precision: 1,
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number',
    label: '3D覆盖流旋转角度',
    propKey: 'coverflowRotate',
    min: -180,
    max: 180,
    step: 5,
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number',
    label: '3D覆盖流缩放比例',
    propKey: 'coverflowScale',
    min: 0.1,
    max: 1,
    step: 0.05,
    precision: 2,
    labelWidth: '120px'
  },
  {
    type: 'xy-form-switch',
    label: '3D覆盖流显示阴影',
    propKey: 'coverflowShadow',
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number',
    label: '3D覆盖流拉伸程度',
    propKey: 'coverflowStretch',
    min: 0,
    max: 100,
    step: 10,
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number',
    label: '同屏展示数量',
    propKey: 'slidesPerView',
    min: 1,
    max: 3,
    step: 0.5,
    precision: 1,
    labelWidth: '120px'
  },
  {
    type: 'xy-form-switch',
    label: '内容居中',
    propKey: 'centeredSlides',
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number',
    label: '图片间距',
    propKey: 'spaceBetween',
    min: 0,
    max: 100,
    step: 5,
    labelWidth: '120px'
  },
  {
    type: 'xy-form-switch',
    label: '自动播放',
    propKey: 'autoplay',
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number',
    label: '播放间隔(ms)',
    labelWidth: '120px',
    propKey: 'delay',
    min: 1000,
    max: 10000,
    step: 500
  },
  {
    type: 'xy-form-switch',
    label: '只剩一张停止播放',
    propKey: 'stopOnLastSlide',
    labelWidth: '120px'
  },
  {
    type: 'xy-form-switch',
    label: '显示分页器',
    propKey: 'showPagination',
    labelWidth: '120px'
  },
  {
    type: 'xy-form-select',
    label: '分页器类型',
    propKey: 'paginationType',
    options: [
      { label: '圆点', value: 'bullets' },
      { label: '分数', value: 'fraction' }
      // { label: '进度条', value: 'progressbar' }
    ],
    labelWidth: '120px'
  },
  {
    type: 'xy-form-select',
    label: '分页器位置',
    propKey: 'paginationPosition',
    options: [
      { label: '底部', value: 'bottom' },
      { label: '顶部', value: 'top' },
      { label: '左侧', value: 'left' },
      { label: '右侧', value: 'right' }
    ],
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number',
    label: '分页器大小',
    propKey: 'paginationBulletSize',
    min: 0,
    step: 1,
    labelWidth: '120px'
  },
  {
    type: 'xy-form-color-picker', // 表单组件
    label: '分页器激活颜色', // 表单名称
    propKey: 'paginationColor', // 表单model字段名称
    labelWidth: '120px'
  },
  {
    type: 'xy-form-color-picker', // 表单组件
    label: '分页器未激活颜色', // 表单名称
    propKey: 'paginationInactiveColor', // 表单model字段名称
    labelWidth: '120px'
  },
  {
    type: 'xy-form-input-number', // 表单组件
    label: '分页器未激活透明度', // 表单名称
    propKey: 'paginationInactiveOpacity', // 表单model字段名称
    min: 0,
    max: 1,
    step: 0.1,
    precision: 1,
    controlsPosition: 'right',
    labelWidth: '120px'
  },
  {
    type: 'xy-form-switch',
    label: '显示导航按钮',
    propKey: 'showNavigation',
    labelWidth: '120px'
  },
  {
    type: 'xy-form-switch',
    label: '鼠标滚轮',
    propKey: 'mousewheel',
    labelWidth: '120px'
  },
  {
    type: 'xy-form-switch',
    label: '无障碍支持',
    propKey: 'a11y',
    labelWidth: '120px'
  },
  {
    type: 'xy-form-swiper-items',
    label: '轮播项', // 表单名称
    propKey: 'items', // 表单model字段名称
    labelWidth: '120px',
    isLanguage: true, // 是否可多语言配置
    isActivityData: true // 是否为动态数据
  }
]
